import React from 'react'
import className from 'classnames/bind'

import VideoPlayer from 'app/components/video-player/video-player.component'
import Text from 'app/components/common/text/text.component'
import { PlayIconRounded } from 'app/components/icons'

import stylesModule from 'app/components/sounds/sound-popup/sound-popup-video-player/sound-popup-video-player.module.scss'
import MultimediaEventService from 'app/services/analitics/multimedia.event.service'

import { Sound } from 'app/components/sounds/types/sound'

const cx = className.bind(stylesModule)

type SoundPopupVideoPlayerProps = {
  sound: Sound
  isSongVisible?: boolean
}

const SoundPopupVideoPlayer = ({
  sound,
  isSongVisible = false,
}: SoundPopupVideoPlayerProps) => {
  const poster = isSongVisible ? sound.songPoster : sound.soundVideoPoster
  const sources = isSongVisible ? sound.songsSrc : sound.videosSrc

  return (
    <>
      <Text
        type="h4"
        modifiers={sound.effect}
        className={cx('sound-popup-video__title')}
      >
        {sound.soundname}
      </Text>
      <VideoPlayer
        placeholder
        classNames={cx('sound-popup-video__player')}
        poster={poster}
        source={{
          type: 'video',
          poster,
          sources,
        }}
        tracks={[]}
        playButtonIcon={
          <PlayIconRounded className={cx('sound-popup-video__play-button')} />
        }
        onPlay={(ref) =>
          MultimediaEventService.sendSoundModalVideoEvent(
            'played',
            sound.id,
            sound.name,
            isSongVisible,
            ref
          )
        }
        onPause={(ref) =>
          MultimediaEventService.sendSoundModalVideoEvent(
            'paused',
            sound.id,
            sound.name,
            isSongVisible,
            ref
          )
        }
        onEnd={(ref) =>
          MultimediaEventService.sendSoundModalVideoEvent(
            'completed',
            sound.id,
            sound.name,
            isSongVisible,
            ref
          )
        }
      />
    </>
  )
}

export default SoundPopupVideoPlayer
